import React from 'react';
import { BodyText, Button, Flex, Gutter, GutterBag, Icon, Image, List } from '@gaiads/telia-react-component-library';
import { Card } from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AbstractImage, AdminProduct, AdminProductTypeEnum, ProductTranslation, UrlImage } from '@cdaas/api-clients/dist/product-service-openapi';

import './ProductInformationCard.scss';

const ProductInformationCard = ({ product, translation }: { product?: AdminProduct; translation?: ProductTranslation }) => {
  const { t } = useTranslation('productscreen');
  const { push } = useHistory();

  const isHardware = product?.type !== AdminProductTypeEnum.Service;

  const handleEditClick = () => {
    if (product) {
      push(`/product/${product.id}/details`);
    }
  };

  return (
    <Card title={t('productInformationCard.title')} alwaysOpenNoChevron>
      <BodyText>
        {t('productInformationCard.productType')}: {isHardware ? t('productInformationCard.hardware') : t('productInformationCard.service')}
      </BodyText>
      <Gutter />
      <GutterBag
        contents={
          isHardware
            ? (product?.images as (AbstractImage & UrlImage)[] | undefined)?.map(image => (
                <Image
                  key={`image-${image.id}`}
                  src={image.small_size_url}
                  className="product-information-card__image"
                  data-testid={`image-${image.id}`}
                  alt=""
                />
              ))
            : [
                <Icon
                  key="image-0"
                  name="service-device"
                  size="xlg"
                  color="gray400"
                  className="product-information-card__image"
                  data-testid="image-0"
                />,
              ]
        }
      />
      <Gutter />
      <BodyText>{translation?.description || product?.description}</BodyText>
      <Gutter />
      {isHardware && (
        <List>
          {translation?.key_selling_points?.map((keySellingPoint, index) => (
            <List.Item key={`key-selling-point-${index}`}>
              <Flex centeredVertically>
                <Icon name="checkmark" size="md" margin={{ right: 'sm' }} />
                {translation.key_selling_points[index] || keySellingPoint}
              </Flex>
            </List.Item>
          ))}
        </List>
      )}
      {/* TODO: tags */}
      <Gutter />
      <Button variant="secondary" iconName="chevron-right" iconOnRight onClick={handleEditClick}>
        {t('productInformationCard.editButton')}
      </Button>
    </Card>
  );
};

export default ProductInformationCard;
